import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import askStyles from './AskMe.module.css';
import styles from './HomeActionSection.module.css';
import analyticsTracker from '../../utils/analytics';
import { useTheme } from '../UI/Theme/ThemeContext';

const services = [
  { title: 'Create Resume', link: '/user/dashboard/resume' },
  { title: 'Apply For Me', link: '/user/dashboard/job-hub' },
  { title: 'Job-connect Me', link: '/user/dashboard/job-hub' },
  { title: 'Cover Letter', link: '/user/dashboard/resume-hub' },
  { title: 'Take Any Mock Exam', link: '/user/dashboard/mock' },
  { title: 'Job Interview Prep', link: '/user/dashboard/resume-hub' },
  { title: 'General Prompting', link: '/chat' },
  { title: 'Career Roadmap', link: '/user/dashboard/career-roadmap' },
  { title: 'Bubble Ai Schools', link: '/school', className: askStyles.svcSchools },
];

const HomeActionSection = ({ isAuth }) => {
  const navigate = useNavigate();
  const { themeName } = useTheme();
  const textColor = themeName === 'dark' ? '#ffffff !important' : '#0C1E28 !important';

  // custom one-time typewriter state to avoid external styling conflicts
  const fullText = 'Your career copilot. Ask me to build resumes, apply to jobs, prepare interviews, simulate any exam, or just chat.';
  const [typed, setTyped] = useState('');
  useEffect(() => {
    let idx = 0;
    const interval = setInterval(() => {
      idx += 1;
      setTyped(fullText.slice(0, idx));
    //   if (idx >= fullText.length) clearInterval(interval);
    }, 120);
    return () => clearInterval(interval);
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (service) => () => {
    let link;
    if (isAuth) link = service.link;
    else {
      // if service is under /user routes, redirect to popin with query, otherwise allow public route
      if (service.link.startsWith('/user')) link = `/popin?${service.link.split('/').pop()}`;
      else link = service.link;
    }
    try { analyticsTracker.trackServiceClick(service.title, link); } catch (_) {}
    if (link.startsWith('http') || link.startsWith('https')) {
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  };

  return (
    <div className={styles.homeActionWrap} aria-hidden={false}>
      <div className={styles.inner}>
        <h2 className={`${styles.introHeader}`} style={{ color: textColor }}>{'Hi, I\'m Bubble Ai'}</h2>
        <div style={{ color: textColor }}>
          <p style={{ margin: 0, color: textColor }}>{typed}</p>
        </div>

        <div className={styles.actionsWrap + ' ' + askStyles.emptyActions}>
          {services.map((s, idx) => (
            <button
              key={s.title}
              className={`${askStyles.svcItem} ${s.className || askStyles['svc' + (idx % 8)] || ''}`}
              onClick={handleClick(s)}
            >
              {s.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeActionSection;
